export type AuthenticationMethod = {
  method: string
  url: string
}

const urls: {[key: string]: string} = {
  login: "/login",
  signup: "/sign-up",
  select_account: "/switch/init",
}

export const getAuthenticationMethod = (method: string): AuthenticationMethod => {
  const url = urls[method];
  return url ? {method, url} : {method: "login", url: "/login"};
}